import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useState } from 'react';
import { getAddressFieldsErrors, getAddressFieldsFailures } from '../AddressFields.utils';
export function useAddressFieldsValidation(param) {
    let { value, errorTexts, showAllErrors, allowEmpty } = param;
    const [touchedFields, setTouchedFields] = useState({});
    const errors = getAddressFieldsErrors(getAddressFieldsFailures(value, {
        allowEmpty
    }), errorTexts);
    const visibleError = (field)=>showAllErrors || touchedFields[field] ? errors[field] : undefined;
    const markTouched = (field)=>setTouchedFields((touched)=>_object_spread_props(_object_spread({}, touched), {
                [field]: true
            }));
    return {
        visibleError,
        markTouched
    };
}
